import React, { Component } from "react";
import {
  Segment, Divider, Container, Grid,
  Form, FormGroup, FormField,
  Radio, FormButton, Dimmer, Loader,
  Popup, Icon
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const UtilsInstance = new Utils();

export class ASiType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      // Active channels
      isChannel1Active: false,
      isChannel2Active: false,
      isChannel3Active: false,
      isChannel4Active: false,
      // Channel ASi versions
      channel1Version21Plus: false,
      channel2Version21Plus: false,
      channel3Version21Plus: false,
      channel4Version21Plus: false,
      // Dimmers
      isChannel1DimmerActive: false,
      isChannel2DimmerActive: false,
      isChannel3DimmerActive: false,
      isChannel4DimmerActive: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "activeChannels", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "asiType/1", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "asiType/2", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "asiType/3", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "asiType/4", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      isChannel1Active: resolvedPromisses[0].channel1,
      isChannel2Active: resolvedPromisses[0].channel2,
      isChannel3Active: resolvedPromisses[0].channel3,
      isChannel4Active: resolvedPromisses[0].channel4,
      channel1Version21Plus: resolvedPromisses[1].version21Plus,
      channel2Version21Plus: resolvedPromisses[2].version21Plus,
      channel3Version21Plus: resolvedPromisses[3].version21Plus,
      channel4Version21Plus: resolvedPromisses[4].version21Plus
    });
  }

  handleASiTypeChange = (channel) => {
    switch (channel) {
      case 1:
        this.setState({ channel1Version21Plus: !this.state.channel1Version21Plus });
        break;
      case 2:
        this.setState({ channel2Version21Plus: !this.state.channel2Version21Plus });
        break;
      case 3:
        this.setState({ channel3Version21Plus: !this.state.channel3Version21Plus });
        break;
      case 4:
        this.setState({ channel4Version21Plus: !this.state.channel4Version21Plus });
        break;
      default:
        break;
    }
  }

  controlDimmer = (channel, show) => {
    switch (channel) {
      case 1:
        this.setState({ isChannel1DimmerActive: show });
        break;
      case 2:
        this.setState({ isChannel2DimmerActive: show });
        break;
      case 3:
        this.setState({ isChannel3DimmerActive: show });
        break;
      case 4:
        this.setState({ isChannel4DimmerActive: show });
        break;
      default:
        break;
    }
  }

  sendASiType = (channel) => {
    this.controlDimmer(channel, true);
    let chosenChannelVersion21Plus = false;

    switch (channel) {
      case 1:
        chosenChannelVersion21Plus = this.state.channel1Version21Plus;
        break;
      case 2:
        chosenChannelVersion21Plus = this.state.channel2Version21Plus;
        break;
      case 3:
        chosenChannelVersion21Plus = this.state.channel3Version21Plus;
        break;
      case 4:
        chosenChannelVersion21Plus = this.state.channel4Version21Plus;
        break;
    }

    console.log("Vou enviar o asi type do canal ", channel, "com valor", chosenChannelVersion21Plus);

    fetch(Constants.REQUEST_IP_ADDRESS + "asiType_POST/" + channel, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ version21Plus: chosenChannelVersion21Plus })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.SEND_ASI_TYPE_SUCCESS_1.concat(channel).concat(Strings.SEND_ASI_TYPE_SUCCESS_2));
      })
      .catch((error) => {
        alert(Strings.SEND_ASI_TYPE_ERROR.concat(channel).concat("'").concat(Strings.ERROR_REASON).concat(error));
      })
      .finally(() => {
        this.controlDimmer(channel, false);
        this.retrieveData();
      });
  }

  componentDidMount = () => {
    this.retrieveData();
  }

  render() {
    return (
      <Container>
        <Segment>
          <Popup position='bottom center' hoverable pinned wide
            trigger={
              <Divider
                horizontal
                style={dividerStyle}>
                {Strings.ASI_NETWORK_VERSION}
                <Icon name="question circle" size="big" color="teal" style={questionIconStyle} />
              </Divider>
            }>
            <Popup.Content>
              <p style={{ textAlign: "justify" }}>{Strings.DISABLED_CHANNELS_POPUP_1}</p>
              <p style={{ textAlign: "justify" }}>{Strings.DISABLED_CHANNELS_POPUP_2}</p>
            </Popup.Content>
          </Popup >

          <Grid columns={2} centered textAlign="center" verticalAlign="middle">
            <Grid.Row>

              <Grid.Column textAlign="center" verticalAlign="middle">

                <Segment disabled={!this.state.isChannel1Active}>
                  <Divider horizontal style={dividerStyle}>{Strings.CHANNEL_1}</Divider>

                  <Form onSubmit={() => { this.sendASiType(1); }}>
                    <FormGroup grouped>
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2}
                        control={Radio}
                        checked={!this.state.channel1Version21Plus}
                        onChange={() => this.handleASiTypeChange(1)} />
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2_1}
                        control={Radio}
                        checked={this.state.channel1Version21Plus}
                        onChange={() => this.handleASiTypeChange(1)} />
                    </FormGroup>

                    <FormButton
                      fluid
                      color="teal"
                      content={Strings.SAVE} />
                  </Form>

                  <Dimmer active={this.state.isChannel1DimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>
                </Segment>

              </Grid.Column>

              <Grid.Column textAlign="center" verticalAlign="middle">

                <Segment disabled={!this.state.isChannel2Active}>
                  <Divider horizontal style={dividerStyle}>{Strings.CHANNEL_2}</Divider>

                  <Form onSubmit={() => { this.sendASiType(2); }}>
                    <FormGroup grouped>
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2}
                        control={Radio}
                        checked={!this.state.channel2Version21Plus}
                        onChange={() => this.handleASiTypeChange(2)} />
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2_1}
                        control={Radio}
                        checked={this.state.channel2Version21Plus}
                        onChange={() => this.handleASiTypeChange(2)} />
                    </FormGroup>

                    <FormButton
                      fluid
                      color="teal"
                      content={Strings.SAVE} />
                  </Form>

                  <Dimmer active={this.state.isChannel2DimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>
                </Segment>

              </Grid.Column>

            </Grid.Row>
            <Grid.Row>

              <Grid.Column textAlign="center" verticalAlign="middle">

                <Segment disabled={!this.state.isChannel3Active}>
                  <Divider horizontal style={dividerStyle}>{Strings.CHANNEL_3}</Divider>

                  <Form onSubmit={() => { this.sendASiType(3); }}>
                    <FormGroup grouped>
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2}
                        control={Radio}
                        checked={!this.state.channel3Version21Plus}
                        onChange={() => this.handleASiTypeChange(3)} />
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2_1}
                        control={Radio}
                        checked={this.state.channel3Version21Plus}
                        onChange={() => this.handleASiTypeChange(3)} />
                    </FormGroup>

                    <FormButton
                      fluid
                      color="teal"
                      content={Strings.SAVE} />
                  </Form>

                  <Dimmer active={this.state.isChannel3DimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>
                </Segment>

              </Grid.Column>

              <Grid.Column textAlign="center" verticalAlign="middle">

                <Segment disabled={!this.state.isChannel4Active}>
                  <Divider horizontal style={dividerStyle}>{Strings.CHANNEL_4}</Divider>

                  <Form onSubmit={() => { this.sendASiType(4); }}>
                    <FormGroup grouped>
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2}
                        control={Radio}
                        checked={!this.state.channel4Version21Plus}
                        onChange={() => this.handleASiTypeChange(4)} />
                      <FormField
                        style={radioStyle}
                        label={Strings.ASI_NETWORK_VERSION_2_1}
                        control={Radio}
                        checked={this.state.channel4Version21Plus}
                        onChange={() => this.handleASiTypeChange(4)} />
                    </FormGroup>

                    <FormButton
                      fluid
                      color="teal"
                      content={Strings.SAVE} />
                  </Form>

                  <Dimmer active={this.state.isChannel4DimmerActive} >
                    <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
                  </Dimmer>
                </Segment>

              </Grid.Column>

            </Grid.Row>
          </Grid>

        </Segment >
      </Container >
    );
  }
}

const dividerStyle = {
  marginTop: "0.5vh"
};

const radioStyle = {
  marginBottom: "0vh",
  marginTop: "0vh"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default ASiType;